import React, { useEffect, useState } from "react";
import { Button, Flex, Text } from "@chakra-ui/react";
import Header from "components/header";
import MatchingFriendship from '../../assets/img/MatchingFriendship.webp';
import MatchingPartnership from '../../assets/img/MatchingPartnership.webp';
import MatchingRomance from '../../assets/img/MatchingRomance.webp';
import useStyles from './style';
import Footer from "components/footerUser";

const MatchingService = props => {
  const styles = useStyles();
  const [activePage, setActivePage] = useState(0);

  useEffect(() => {
    if (props?.location?.hash?.split('#')[1]) {
      setActivePage(props?.location?.hash?.split('#')[1])
    }
  }, [])

  return (
    <Flex direction="column" gap={5}>
      <Header active="home" />
      <Flex justifyContent="center" mt={16} width="100%">
        <Flex maxWidth={1080} overflowX="hidden" width="100%" direction="column">
          <Flex gap={{ sm: 3, md: 5 }} flexWrap="nowrap" overflowX="auto" style={{ scrollbarWidth: 'none' }} width="100%">
            <Flex direction="column" flex={1}>
              <img src={MatchingPartnership} alt="profile" className={styles.img} />
              <Flex width={{ sm: 150, md: '100%' }} backgroundColor={activePage == 0 ? "#B02418" : "#016A70"} cursor="pointer" borderTopRadius={10} mb={2} p={2} h={70} justifyContent="center" alignItems="center" onClick={() => setActivePage(0)}>
                <Text as="h1" fontSize={{ sm: 'sm', md: 'md' }} color="#fff" fontWeight="bold" textAlign="center">PARTNERSHIP MATCHING</Text>
              </Flex>
            </Flex>
            <Flex direction="column" flex={1}>
              <img src={MatchingRomance} alt="profile" className={styles.img} />
              <Flex width={{ sm: 150, md: '100%' }} backgroundColor={activePage == 1 ? "#B02418" : "#016A70"} cursor="pointer" borderTopRadius={10} mb={2} p={2} h={70} justifyContent="center" alignItems="center" onClick={() => setActivePage(1)}>
                <Text as="h1" fontSize={{ sm: 'sm', md: 'md' }} color="#fff" fontWeight="bold" textAlign="center">ROMANCE MATCHING</Text>
              </Flex>
            </Flex>
            <Flex direction="column" flex={1}>
              <img src={MatchingFriendship} alt="profile" className={styles.img} />
              <Flex width={{ sm: 150, md: '100%' }} backgroundColor={activePage == 2 ? "#B02418" : "#016A70"} cursor="pointer" borderTopRadius={10} mb={2} p={2} h={70} justifyContent="center" alignItems="center" onClick={() => setActivePage(2)}>
                <Text as="h1" fontSize={{ sm: 'sm', md: 'md' }} color="#fff" fontWeight="bold" textAlign="center">FRIENDSHIP MATCHING</Text>
              </Flex>
            </Flex>
          </Flex>
          <Flex direction="column" padding={5} borderWidth={1} borderColor="#B02418" borderRadius={20}>
            {activePage == 0 ? (
              <Flex direction="column" gap={3}>
                <Text fontSize={{ sm: 'sm', md: 'md' }}>Layanan Matching Partnership memberikan analisis untuk menilai dan meningkatkan kecocokan dalam kemitraan bisnis. Hasil yang ditampilkan dalam bentuk grafik batang (General Matched %) menunjukkan tingkat kecocokan umum antara mitra, yang mencakup berbagai aspek penting seperti gaya hubungan (Relation Style), interaksi (Interaction), dan cara menangani masalah (Deal With). Selain itu, layanan ini juga menyediakan panduan kemitraan (Partnership Guidance) untuk membantu mitra bekerja sama lebih efektif dan harmonis.</Text>
                <Text fontSize={{ sm: 'sm', md: 'md' }}>Layanan ini juga mencakup analisis harian yang ditampilkan dalam bentuk grafik batang (Matched %), yang menunjukkan kecocokan harian antara mitra (Daily Partnership). Perspektif bisnis (Business Perspective), rekomendasi untuk transaksi yang baik (Good Dealing), dan tips untuk meningkatkan kinerja (Improving Performance), juga disertakan untuk membantu mitra memaksimalkan potensi kemitraan setiap hari. Dengan memahami situasi hari ini (Situation of The Day), mitra dapat merencanakan strategi yang tepat dan meningkatkan produktivitas serta keberhasilan bisnis.</Text>
              </Flex>
            ) : activePage == 1 ? (
              <Flex direction="column" gap={3}>
                <Text fontSize={{ sm: 'sm', md: 'md' }}>Layanan Matching Romance menyediakan analisis komprehensif untuk menilai dan meningkatkan kecocokan dalam hubungan romantis. Hasil analisis ditampilkan dalam bentuk grafik batang (General Matched %), yang menunjukkan tingkat kecocokan umum antara pasangan. Layanan ini mencakup penilaian kecocokan romansa (Romance Matched) serta panduan untuk hubungan romantis (Romance Guidance), membantu pasangan memahami tingkat kompatibilitas (Romance Compatibility). Selain itu, layanan ini juga menawarkan panduan interaksi (Guide Interaction) yang membantu pasangan berkomunikasi dan berinteraksi dengan lebih baik dalam kehidupan cinta (Love Life) dan kehidupan seks (Sex Life).</Text>
                <Text fontSize={{ sm: 'sm', md: 'md' }}>Setiap hari, layanan ini juga menyediakan analisis harian yang ditampilkan dalam bentuk grafik batang (Today Matched %), yang menunjukkan kecocokan harian antara pasangan (Daily Romance). Dengan panduan harian untuk romansa (Romance Guidance), pasangan dapat memahami situasi hari ini (Situation of The Day) dan menyesuaikan interaksi untuk memaksimalkan keharmonisan dan kebahagiaan dalam hubungan. Dengan layanan ini, pasangan dapat membangun dan memelihara hubungan yang lebih kuat dan memuaskan, menghadapi tantangan bersama, dan menikmati kehidupan romantis yang lebih harmonis setiap hari.</Text>
              </Flex>
            ) : activePage == 2 ? (
              <Flex direction="column" gap={3}>
                <Text fontSize={{ sm: 'sm', md: 'md' }}>Layanan Matching Friendship menyediakan analisis untuk menilai dan memperkuat kecocokan dalam persahabatan. Hasil analisis ini ditampilkan dalam bentuk grafik batang (General Matched %), yang menggambarkan tingkat kesesuaian umum antara teman-teman. Melalui penilaian kecocokan persahabatan (Friendship Matched), layanan ini menawarkan panduan hubungan (Guide on Friendship) dan berbagai tips serta ide (Tips and Ideas) untuk membangun interaksi yang lebih baik. Dengan memahami aspek-aspek penting dari interaksi (Interaction) dalam persahabatan, individu dapat menciptakan hubungan yang lebih harmonis dan saling mendukung.</Text>
                <Text fontSize={{ sm: 'sm', md: 'md' }}>Selain itu, layanan ini juga menyediakan analisis harian yang ditampilkan dalam bentuk grafik batang (Today Matched %), yang menunjukkan tingkat kecocokan harian antara teman-teman (Daily Friendship). Panduan harian ini mencakup aktivitas dan perjalanan yang dapat dilakukan bersama teman (Friends Activity and Traveling), serta memberikan gambaran tentang situasi hari ini (Situation of The Day). Dengan informasi ini, teman-teman dapat merencanakan aktivitas yang menyenangkan dan bermanfaat, memperkuat ikatan persahabatan mereka, dan menikmati waktu bersama dengan lebih baik setiap harinya.</Text>
              </Flex>
            ) : null}
            <Flex justify="end" align="end">
              <Button
                // width="100%"
                bgColor="#B02418"
                color='white'
                fontSize={{ sm: 'xs', md: 'sm' }}
                fontWeight='500'
                borderRadius='5px'
                onClick={() => window.location.assign('/pricing#matching')}
                px='15px'
                py='5px'>
                Lihat pricing
              </Button>
            </Flex>
          </Flex>
          <table id="tableMatching">
            <tr>
              <th><Text fontSize={{ sm: 'sm', md: 'md' }}>No</Text></th>
              <th><Text fontSize={{ sm: 'sm', md: 'md' }}>Range Value</Text></th>
              <th><Text fontSize={{ sm: 'sm', md: 'md' }}>Category</Text></th>
              <th><Text fontSize={{ sm: 'sm', md: 'md' }}>Deskripsi</Text></th>
            </tr>
            <tr>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>1</Text></td>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>{`- < 50%`}</Text></td>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>Average</Text></td>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>Perlu usaha besar untuk saling mengerti dan memahami</Text></td>
            </tr>
            <tr>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>2</Text></td>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>51% - 60</Text>%</td>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>Moderate</Text></td>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>Mengisi dan mengurangi kelemahan</Text></td>
            </tr>
            <tr>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>3</Text></td>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>61% - 70%</Text></td>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>Intermediate</Text></td>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>Memberi dorongan dan memperbaiki kekurangan</Text></td>
            </tr>
            <tr>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>4</Text></td>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>71% - 80%</Text></td>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>Leading</Text></td>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>Meningkatkan kekuatan bersama</Text></td>
            </tr>
            <tr>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>5</Text></td>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>81% - 90%</Text></td>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>Advance</Text></td>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>Kombinasi yang erat</Text></td>
            </tr>
            <tr>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>6</Text></td>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>91% - 100%</Text></td>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>The BEST</Text></td>
              <td><Text fontSize={{ sm: 'sm', md: 'md' }}>Seiring sejalan</Text></td>
            </tr>
          </table>
        </Flex>
      </Flex>
      <Footer />
    </Flex>
  )
}

export default MatchingService;
